import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader, StatCard, StatusBadge, fmtUSD, fmtDate } from "@/components/ui-bits";
import { Coins } from "lucide-react";

export default function Rewards() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/rewards/mine").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader title="Rewards" subtitle="Activity credits accrued from your active contribution plans." />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <StatCard label="Available Rewards" value={fmtUSD(user?.rewards_balance)} accent icon={Coins} />
        <StatCard label="Total Earned" value={fmtUSD(user?.total_rewards_earned)} icon={Coins} />
        <StatCard label="Total Withdrawn" value={fmtUSD(user?.total_withdrawn)} />
      </div>
      <div className="glass p-5">
        <h3 className="font-display text-lg font-bold mb-4">Reward History</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-[11px] uppercase tracking-wider text-[#475569]">
              <tr className="border-b border-white/5"><th className="text-left py-2">Month</th><th className="text-right">Amount</th><th className="text-right">Status</th></tr>
            </thead>
            <tbody data-testid="rewards-table">
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="py-3 text-[#94A3B8]">{formatMonth(r.month, r.created_at)}</td>
                  <td className="text-right font-mono text-[#00F0FF]">+{fmtUSD(r.amount)}</td>
                  <td className="text-right"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={3} className="py-8 text-center text-[#475569]">No rewards yet — start a contribution to begin accruing</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function formatMonth(month, fallbackDate) {
  if (month && /^\d{4}-\d{2}$/.test(month)) {
    const [y, m] = month.split("-");
    const d = new Date(Number(y), Number(m) - 1, 1);
    return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  }
  if (!fallbackDate) return "—";
  const d = new Date(fallbackDate);
  return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
}
